import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { ComponentProps } from "react";

export type PopoverAnchorProps = ComponentProps<typeof PopoverPrimitive.Anchor>;

export const PopoverAnchor = (props: PopoverAnchorProps) => (
  <PopoverPrimitive.Anchor data-slot="popover-anchor" {...props} />
);
